
<div class="logo" style="padding:9px">
	<a [routerLink]="['/']" class="logo-normal">
        <div class="logo-normal text-center">
            <img height="60px" src="../assets/img/titles/title_1.png" /><b>{{instance}}</b>
        </div>
	</a>
</div>

<div class="sidebar-wrapper">

    @if (!isLoggedIn()) {
        <div class="user text-center">
            <button class="btn btn-primary" (click)="login()">Login</button>
        </div>
    }

    @if (isLoggedIn()) {
        <div class="user">
            <div class="photo">
                <i class="fa fa-user fa-3x"></i>
            </div>
            <div class="info">
                <button data-bs-toggle="collapse" type="button" data-bs-target="#collapseProfile" class="btn btn-link text-decoration-none border-0 bg-transparent   " aria-expanded="false" aria-controls="collapseProfile">
                    <span>
                        {{userInfo().Name}}
                    </span>
                </button>
                <div class="clearfix"></div>
                <div class="collapse" id="collapseProfile">
                    <ul class="nav">
                        <li>
                            <span class="sidebar-list">{{userInfo().PreferredUsername}}</span>
                        </li>
                        <li>
                            <span class="sidebar-list">{{userInfo().Email}}</span>
                        </li>
                        <li>
                            <span class="sidebar-list">{{userInfo().PhoneNumber}}</span>
                        </li>
                        <li>
                            <span class="sidebar-list"><b>Institution / Study Site</b></span>
                            <ul style="margin-left: 15px; list-style-type: none; padding: 0;">
                                <li>
                                    <span class="sidebar-list">{{userInfo().InstitutionsStudySites.Name}}</span>
                                </li>
                            <!--@for (institutionStudySite of userInfo().InstitutionsStudySites; let i = $index; track $index) {
                                <li>
                                    <span class="sidebar-list">{{institutionStudySite.Name}}</span>
                                </li>
                            }-->
                            </ul>
                        </li>
                        <!--li>
                            <a href="">
                                <span class="sidebar-mini">CP</span>
                                <span class="sidebar-normal">Change Password</span>
                            </a>
                        </li-->
                        <!--li>
                            <a>
                                <span class="sidebar-mini">RO</span>
                                <span class="sidebar-normal">
                                    <ul style="list-style:none;">
                                        @for (role of userInfo().idTokenClaims.roles; track $index) {
                                            <li>{{role}}</li>
                                        }
                                    </ul>
                                </span>
                            </a>
                        </li-->
                        <li class="text-center" style="padding-top:10px">
                            <button class="btn btn-danger" (click)="logout()">Logout</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    }
    
	<!--<div *ngIf="isNotMobileMenu()">
        <form class="navbar-form navbar-left navbar-search-form" role="search">
            <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-search"></i></span>
                <input type="text" value="" class="form-control" placeholder="Search...">
            </div>
        </form>
        <ul class="nav nav-mobile-menu">
            <li>
                <a href="#stats" class="dropdown-toggle btn-magnify" data-toggle="dropdown">
                    <i class="ti-panel"></i>
                    <p>Stats</p>
                </a>
            </li>
            <li class="dropdown">
                <a href="#notifications" class="dropdown-toggle btn-rotate" data-toggle="dropdown">
                    <i class="ti-bell"></i>
                    <span class="notification">5</span>
                    <p class="hidden-md hidden-lg">
                        Notifications
                    </p>
                </a>
                <ul class="dropdown-menu">
                    <li><a href="#not1">Notification 1</a></li>
                    <li><a href="#not2">Notification 2</a></li>
                    <li><a href="#not3">Notification 3</a></li>
                    <li><a href="#not4">Notification 4</a></li>
                    <li><a href="#another">Another notification</a></li>
                </ul>
            </li>
            <li>
                <a class="btn-rotate">
                    <i class="ti-settings"></i>
                    <p class="hidden-md hidden-lg">
                        Settings
                    </p>
                </a>
            </li>
        </ul>
    </div>-->
    <ul class="nav">
        @for (menuitem of menuItems; track $index) {
            <li routerLinkActive="active">
                <!--If is a single link-->
                @if (menuitem.type === 'link') {
                    <a [routerLink]="[menuitem.path]">
                        <i class="{{menuitem.icontype}}"></i>
                        <p>{{menuitem.title}}</p>
                    </a>
                }
                <!--If it have a submenu-->
                @if (menuitem.type === 'sub') {
                    <a data-bs-toggle="collapse" role="button" href="#{{menuitem.title}}" aria-expanded="false" aria-controls="{{menuitem.title}}">
                        <i class="{{menuitem.icontype}}"></i>
                        <p>{{menuitem.title}}<b class="caret"></b></p>
                    </a>

                    <!--Display the submenu items-->
                    <div id="{{menuitem.title}}" class="collapse">
                        <ul class="nav">
                            @for (childitem of menuitem.children; track $index) {
                                <li routerLinkActive="active">
                                    <a [routerLink]="[menuitem.path, childitem.path]">
                                        <span class="sidebar-mini">{{childitem.ab}}</span>
                                        <span class="sidebar-normal">{{childitem.title}}</span>
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                }
            </li>
        }
    </ul>
</div>
